var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccuracyTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50008 5.33341C6.02675 5.33341 4.83341 6.52675 4.83341 8.00008C4.83341 9.47341 6.02675 10.6667 7.50008 10.6667C8.97341 10.6667 10.1667 9.47341 10.1667 8.00008C10.1667 6.52675 8.97341 5.33341 7.50008 5.33341ZM13.4601 7.33341C13.3091 5.9815 12.7028 4.72111 11.741 3.75921C10.7791 2.79731 9.51867 2.19109 8.16675 2.04008V0.666748H6.83341V2.04008C5.4815 2.19109 4.22111 2.79731 3.25921 3.75921C2.29731 4.72111 1.69109 5.9815 1.54008 7.33341H0.166748V8.66675H1.54008C1.69109 10.0187 2.29731 11.2791 3.25921 12.241C4.22111 13.2028 5.4815 13.8091 6.83341 13.9601V15.3334H8.16675V13.9601C9.51867 13.8091 10.7791 13.2028 11.741 12.241C12.7028 11.2791 13.3091 10.0187 13.4601 8.66675H14.8334V7.33341H13.4601ZM7.50008 12.6667C4.92008 12.6667 2.83341 10.5801 2.83341 8.00008C2.83341 5.42008 4.92008 3.33341 7.50008 3.33341C10.0801 3.33341 12.1667 5.42008 12.1667 8.00008C12.1667 10.5801 10.0801 12.6667 7.50008 12.6667Z",
    fill: "#959EB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccuracyTarget);
export default __webpack_public_path__ + "static/media/accuracy-target.8692400ecf8a224de95fa8534dded187.svg";
export { ForwardRef as ReactComponent };